// @ts-nocheck
import { motion } from 'framer-motion';
import { Text, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';
import { REPLACEMENTS } from './constants';

export function Comparison() {
  const isMobile = useIsMobile();
  const { sectionReveal } = useMotion();

  return (
    <YStack
      paddingVertical={120}
      paddingHorizontal="$5"
      backgroundColor="$background"
    >
      <YStack maxWidth={700} alignSelf="center" width="100%">
        <motion.div
          {...sectionReveal}
          viewport={{ once: true }}
          style={{ marginBottom: 48 }}
        >
          <Text
            fontSize={isMobile ? 32 : 44}
            fontWeight="700"
            letterSpacing={-1.5}
            lineHeight={isMobile ? 38 : 52}
            color="$color12"
          >
            Replace your stack
          </Text>
        </motion.div>

        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          fontFamily: "'Space Grotesk', sans-serif",
        }}>
          <colgroup>
            <col style={{ width: '35%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '40%' }} />
          </colgroup>
          <thead>
            <tr>
              <th style={{ padding: '12px 0', textAlign: 'left', fontSize: 12, fontWeight: 600, color: 'var(--color7)', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid var(--color4)' }}>
                Tool
              </th>
              <th style={{ padding: '12px 0', textAlign: 'center', fontSize: 12, fontWeight: 600, color: 'var(--color7)', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid var(--color4)' }}>
                Price
              </th>
              <th style={{ padding: '12px 0', textAlign: 'right', fontSize: 12, fontWeight: 600, color: 'var(--color7)', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid var(--color4)' }}>
                Torch
              </th>
            </tr>
          </thead>
          <tbody>
            {REPLACEMENTS.map((item) => (
              <tr key={item.tool}>
                <td style={{ padding: '16px 0', fontSize: 15, color: 'var(--color8)', fontWeight: 500, textDecoration: 'line-through', borderBottom: '1px solid var(--color4)' }}>
                  {item.tool}
                </td>
                <td style={{ padding: '16px 0', textAlign: 'center', fontSize: 13, color: 'var(--color7)', borderBottom: '1px solid var(--color4)' }}>
                  {item.price}
                </td>
                <td style={{ padding: '16px 0', textAlign: 'right', fontSize: 15, color: 'var(--color11)', fontWeight: 600, borderBottom: '1px solid var(--color4)' }}>
                  {item.replacement}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Text
          fontSize={isMobile ? 20 : 24}
          fontWeight="700"
          color="$accentBackground"
          letterSpacing={-0.5}
          marginTop={48}
        >
          Save $30-80/mo per user
        </Text>
        <Text fontSize={15} color="$color8" marginTop="$2">
          Replace 3-5 subscriptions with one workspace.
        </Text>
      </YStack>
    </YStack>
  );
}
